import { Component, Input, OnInit } from "@angular/core";
import * as Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
HighchartsMore(Highcharts);
import HC_solid_gauge from "highcharts/modules/solid-gauge";
HC_solid_gauge(Highcharts);
@Component({
  selector: "app-pie-chart",
  templateUrl: "./pie-chart.component.html",
  styleUrls: ["./pie-chart.component.scss"],
})
export class PieChartComponent implements OnInit {
  defaultData = { Value: 0 };
  @Input("data")
  set in(val) {
    if (val) {
      val.Value = Number(parseFloat(val.Value).toFixed(2));
      // this.solidgauagechart(val);
      this.plotGraph(val);
    } else {
      // this.solidgauagechart(this.defaultData);
      this.plotGraph(this.defaultData);
    }
  }
  highcharts = Highcharts;

  solidGaugeChartOptions = {};
  constructor() {}

  ngOnInit() {
    // this.solidgauagechart(this.defaultData);
    this.plotGraph(this.defaultData);
  }
  plotGraph(data) {
    return (this.solidGaugeChartOptions = {
      chart: {
        type: "gauge",
        plotBackgroundColor: null,
        plotBackgroundImage: null,
        plotBorderWidth: 0,
        plotShadow: false,
        spacing: 0,
        backgroundColor: "transparent",
      },

      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      pane: {
        startAngle: -150,
        endAngle: 150,
        size: "100%",
        background: {
          backgroundColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, "transparent"],
              [1, "transparent"],
            ],
          },
          borderWidth: 0,
          outerRadius: "100%",
          innerRadius: "60%",
        },
      },

      // the value axis
      yAxis: {
        min: 0,
        max: 100,
        minorTickInterval: "auto",
        minorTickWidth: 0,
        minorTickLength: 10,
        minorTickPosition: "inside",
        minorTickColor: "#666",
        tickPixelInterval: 30,
        tickWidth: 0,
        tickPosition: "outside",
        tickLength: 10,
        tickColor: "#666",
        startOnTick: false,
        minPadding: 100,
        labels: {
          step: 2,
          rotation: "auto",
          overflow: "justify",
          distance: -20,
          style: {
            color: "#595959",
            fontWeight: "bold",
            marginBottom: 100,
            fontSize: 13,
          },
        },
        title: {
          text: "",
        },
        plotBands: [
          {
            from: 65,
            to: 100,
            innerRadius: "70%",
            color: "#81D529", // green
          },
          {
            from: 65,
            to: 85,
            innerRadius: "70%",
            color: "#FDBC6F", // yellow
          },
          {
            from: 0,
            to: 65,
            innerRadius: "70%",
            color: "#FF7B7B", // red
          },
        ],
      },

      tooltip: {
        time: {
          useUTC: false,
        },
        pointFormat:
          '<tr style="font-size:14px;"><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.2f} ' +
          "%" +
          "</b></td></tr>",
        footerFormat: "</table>",
        shared: true,
        useHTML: true,
        backgroundColor: "#eeeeee",
        borderColor: "#eeeeee",
      },
      plotOptions: {
        solidgauge: {
          pointStart: 30,
          innerRadius: "60%",
        },
      },
      series: [
        {
          name: data.name || "Value",
          data: [data.Value],
          tooltip: {
            valueSuffix: "",
          },
          dataLabels: {
            enabled: true,
            color: "black",
            fontWeight: "lighter",
            format: `${data.Value} %`,
            style: {
              fontSize: 15,
            },
            // backgroundColor: "white",
          },
        },
      ],
    });
  }
  solidgauagechart(data) {
    return (this.solidGaugeChartOptions = {
      chart: {
        type: "solidgauge",
        backgroundColor: "",
        // marginTop: -10,
        margin: 0,
        reflow: true,
        style: { fontFamily: "sfpro-r" },
      },
      credits: {
        enabled: false,
        style: {
          color: "#999999",
          cursor: "pointer",
          fontSize: "9px",
        },
        text: "Highcharts.com",
      },
      title: {
        text: "",
      },
      subtitle: {
        align: "right",
        useHTML: true,
      },

      legend: {
        enabled: true,
        align: "center",
        verticalAlign: "bottom",
        itemStyle: {
          color: "var(--graph-text-color)",
        },
        labels: {
          enabled: true,
        },
        symbolHeight: 0.001,
        symbolWidth: 0.001,
        symbolRadius: 0.001,
      },
      pane: {
        // center: ["50%", "50%"],
        size: "90%",
        background: {
          backgroundColor: "#DFDFE0",
          innerRadius: "60%",
          outerRadius: "90%",
          borderWidth: 0,
        },
        dial: {
          backgroundColor: "#000000",
          baseLength: "70%",
          baseWidth: 5,
          borderColor: "#cccccc",
          borderWidth: 0,
          radius: "80%",
          rearLength: "30%",
          topWidth: 1,
        },
      },

      yAxis: {
        labels: {
          enabled: true,
        },
        min: 0,
        max: 100,
        lineWidth: 0,
        tickPositions: [],
      },
      tooltip: {
        time: {
          useUTC: false,
        },
        pointFormat:
          '<tr style="font-size:14px;"><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.2f} ' +
          "%" +
          "</b></td></tr>",
        footerFormat: "</table>",
        shared: true,
        useHTML: true,
        backgroundColor: "#eeeeee",
        borderColor: "#eeeeee",
      },
      plotOptions: {
        solidgauge: {
          innerRadius: "70%",
          outerRadius: "90%",
          linecap: "round",
          stickyTracking: false,
          rounded: false,
          dataLabels: {
            y: 50,
            borderWidth: 0,
            useHTML: false,
          },
        },
      },

      series: [
        {
          type: "solidgauge",
          showInLegend: false,
          name: data.name || "Value",
          rounded: false,
          data: [
            {
              color: "#5599FF",
              backgroundColor: "#DFDFE0",
              radius: "90%",
              innerRadius: "60%",
              outerRadius: "90%",
              y: data.Value,
              dataLabels: {
                y: -20,
                // format: "{y}%",
                formatter: function () {
                  // return 65+ '%'
                  return `<div style="position:relative;top:-17px;"><div>${
                    data.Value
                  }%</div><span style="font-size:14px;position:relative;top:-15px;left:10px;color:#45BB27">${
                    data.diff_value ? data.diff_value : 0
                  } % 
                  <i class= 'fa fa-arrow-up'></i></span><div style="font-size:16px;position:relative;top:-18px;left:7px">Today</div></div>`;
                },
                borderWidth: 0,
                style: {
                  fontSize: "30px",
                  color: "var(--graph-text-color)",
                  fontWeight: "lighter",
                },
                useHTML: true,
              },
            },
          ],
        },
      ],
    });
  }
}
